module.exports = __webpack_public_path__ + "static/media/1012700.7b0e8a29.jpg";